export function Spinner({ lg }: { lg?: boolean }) {
  return <span className={`wb-spinner ${lg ? 'wb-spinner--lg' : ''}`} aria-hidden="true" />;
}

export function LoadingLabel({ label }: { label: string }) {
  return (
    <div className="wb-row wb-center wb-gap-8 wb-sub" role="status" aria-live="polite">
      <Spinner />
      <span>{label}</span>
    </div>
  );
}
